import { RecoilRoot } from 'recoil'
import IntlProvider from './components/intl-provider'
import { BrowserRouter } from 'react-router-dom'
import { NavigationContainer } from './components/navigation-container/navigation-container'

// import default style
import './styles/app.css'

export const App = () => {
  return (
    <RecoilRoot>
      <IntlProvider>
        <BrowserRouter>
          <NavigationContainer />
        </BrowserRouter>
      </IntlProvider>
    </RecoilRoot>
  )
}